<template>
    <div class="reference-similars-wrapper" v-show="isShow">
        <div class="textarea-recommend-tit">{{ $t("zhiji.knowlege.quesEditModal.recomQues") }}</div>
        <ul v-if="similars.length > 0" class="refer-similars-list scroll-tracker">
            <li @click="selectReferenceSimilar(item, index)" v-for="(item, index) in similars" :key="index">{{ item }}</li>
        </ul>
        <div class="reference-tips" v-else>{{ status }}</div>
    </div>
</template>

<script>
export default {
    props: ["referenceSimilars"],
    name: "ReferenceRecSimilars",
    data() {
        return {
            similars: this.referenceSimilars.data,
            status: "",
            isShow: true
        };
    },
    watch: {
        referenceSimilars: {
            handler(newValue) {
                this.similars = newValue.data;
                this.status = newValue.status === "done" ? this.$t("zhiji.common.noData") : this.$t("zhiji.common.dataReading");
                if (this.similars.length > 0) {
                    this.isShow = true;
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        selectReferenceSimilar(item, index) {
            this.similars.splice(index, 1);
            this.$emit("selectReferenceSimilar", {
                value: item
            });

            if (this.similars.length === 0) {
                this.isShow = false;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.reference-similars-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 330px;
    border: 1px solid #d8e4f0;
    border-radius: 4px;

    .textarea-recommend-tit {
        padding: 4px 16px 5px;
        background: #f2f7fb;
        border-radius: 4px 4px 0 0;
    }

    .refer-similars-list {
        flex: 1;
        overflow-y: auto;

        li {
            padding: 4px 16px 5px;

            &:hover {
                color: #2ec2ff;
                background: #e3edf6;
                cursor: pointer;
            }
        }
    }

    &::after {
        position: absolute;
        top: 150px;
        left: -12px;
        width: 12px;
        height: 22px;
        display: inline-block;
        content: "";
        background: url("@{zhijiStaticImagePath}class-spr.png") no-repeat;
        background-position: -244px -96px;
    }
    .reference-tips {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #9b9ba3;
    }
}
</style>
